
const apiClient = require('./server').default;

export default apiClient;
